// @flow
import React from 'react'
import classNames from 'classnames'
import { Button } from '@material-ui/core'

import { prussian, peach, white, tomato } from 'constants/inlineStyles'

type Props = {|
  label: string,
  url?: ?string,
  hrefAction?: ?string, // not a link, example: mailto or tel://
  type: 'primary' | 'secondary' | 'action' | 'overflow',
  onClick?: any,
  style: Object,
  dataTestid?: string
|}

let styles = {}
// TODO (quinkinser) make use of children instead of label prop, but keep aria label
const FlyerButton = ({
  label,
  url,
  type,
  onClick,
  style,
  hrefAction,
  dataTestid
}: Props) => {
  const btnClass = classNames({
    'flyer-button': true
  })
  const colorSchemes = {
    primary: styles.primaryColors,
    secondary: styles.secondaryColors,
    third: styles.overflowButtonColors,
    fourth: styles.overflowButtonColors,
    fifth: styles.overflowButtonColors
  }

  return url ? (
    <a href={url} target="_blank" rel="noopener noreferrer" aria-label={label}>
      <Button
        className={btnClass}
        style={{ ...colorSchemes[type], ...style }}
        onClick={onClick}
        data-testid={dataTestid}
      >
        {label}
      </Button>
    </a>
  ) : (
    <Button
      className={btnClass}
      style={{ ...colorSchemes[type], ...style }}
      onClick={onClick}
      href={hrefAction}
    >
      {label}
    </Button>
  )
}

FlyerButton.defaultProps = {
  onClick: () => {},
  buttonProps: {},
  url: null,
  hrefAction: null,
  dataTestid: 'flyer-button-generic'
}

styles = {
  primaryColors: {
    color: prussian,
    backgroundColor: peach,
    borderColor: peach
  },
  secondaryColors: {
    color: white,
    backgroundColor: prussian
  },
  actionColors: {
    color: white,
    backgroundColor: tomato
  },
  overflowButtonColors: {
    backgroundColor: white,
    color: prussian
  }
}

export default FlyerButton



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerDetail/components/FlyerDetailMenu/components/FlyerButton.js